<style>
    .unstyled-button {
        background: transparent;
        border: 0;
        color: inherit;
        font: inherit;
        letter-spacing: inherit;
        margin: 0;
        padding: 0;
        text-align: inherit;
        text-decoration: inherit;
        text-transform: inherit;
    }
    .unstyled-button:focus{
      outline : none !important;

    }

    .unstyled-button:not(:disabled) {
        cursor: pointer;
    }

    .unstyled-button:disabled {
        opacity: 0.5;
    }

    .unstyled-button:disabled:hover,
    button.like-link.no-underline:hover {
        text-decoration: none;
    }
</style>

<template>
    <button :type="type" :class="{'unstyled-button': true, 'like-link': link, 'no-underline': noUnderline}" v-bind="$attrs" @click="$emit('click', $event)">
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            type: {default: 'button'},
            link: Boolean,
            noUnderline: Boolean
        }
    };
</script>
